import React from 'react';
import { useNavigate } from 'react-router-dom';

const OnExam = () => {
  const navigate = useNavigate();

  const examItems = [
    {
      id: 'semStetho',
      name: 'SemStetho',
      description: 'Digital Stethoscope - Record and analyze heart and lung sounds with professional-grade audio quality.',
      route: '/on-exam/stetho',
      color: 'bg-blue-500',
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
        </svg>
      )
    },
    {
      id: 'semBPM',
      name: 'SemBPM',
      description: 'Blood Pressure Monitor - Measure and track your blood pressure with accurate readings.',
      route: '/on-exam/bp',
      color: 'bg-red-500',
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
      )
    },
    {
      id: 'semGluco',
      name: 'SemGluco',
      description: 'Glucose Monitor - Track your blood glucose levels for better diabetes management.',
      route: '/on-exam/gluco',
      color: 'bg-purple-500',
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      )
    }
  ];

  const handleItemClick = (route) => {
    navigate(route);
  };

  return (
    <div className="min-h-screen bg-gray-50 pt-20 pb-8 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900">On Exam</h1>
          <p className="text-xl text-gray-600 mt-2">Medical examination tools and devices</p>
        </div>

        {/* Exam Items Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {examItems.map((item) => (
            <div
              key={item.id}
              onClick={() => handleItemClick(item.route)}
              className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 cursor-pointer overflow-hidden group"
            >
              {/* Item Image */}
              <div className={`${item.color} p-8 flex items-center justify-center`}>
                <div className="bg-white bg-opacity-20 rounded-lg p-4">
                  {item.icon}
                </div>
              </div>

              {/* Item Content */}
              <div className="p-6">
                <h2 className="text-2xl font-semibold text-gray-900 mb-2">
                  {item.name}
                </h2>
                <p className="text-gray-600 mb-4">
                  {item.description}
                </p>
                
                {/* View Details Button */}
                <div className="flex items-center justify-between">
                  <span className="text-blue-600 font-medium group-hover:text-blue-700">
                    Open
                  </span>
                  <svg
                    className="w-5 h-5 text-gray-400 group-hover:text-gray-600 transform group-hover:translate-x-1 transition-transform duration-200"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OnExam;










